module.exports = __webpack_public_path__ + "static/media/instagram-light-filled.2ecf2833.svg";